import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { LoadingScreen } from './components/loading/LoadingScreen';
import { useMediaLoader } from './hooks/media/useMediaLoader';
import { projects } from './data/projects';
import { useAppStore } from './store/useAppStore';

export default function App() {
  const currentPage = useAppStore(state => state.currentPage);
  const { allMediaLoaded } = useMediaLoader(projects);

  return (
    <Router>
      {currentPage === 'loading' ? (
        <LoadingScreen />
      ) : (
        <Routes>
          <Route path="/" element={<Home allMediaLoaded={allMediaLoaded} />} />
          <Route path="/about" element={<About />} />
        </Routes>
      )}
    </Router>
  );
}
